import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Platform } from 'react-native';
import { Path } from 'react-native-svg';
import { arc } from 'd3-shape';
var isWeb = Platform.OS === 'web';
var DONUT_SIZE = 180;
var activeArcLoader = arc().innerRadius(52 - 5).outerRadius(DONUT_SIZE / 2 + 2 * 2.5);
var arcLoader = arc().outerRadius(DONUT_SIZE / 2).innerRadius(52);
export var PieSlice = props => {
  var isActive = props.isActive,
    color = props.color,
    arcData = props.arcData,
    onSelected = props.onSelected;
  var _useState = useState(''),
    path = _useState[0],
    setPath = _useState[1];
  useEffect(() => {
    setPath(isActive ? activeArcLoader(arcData) : arcLoader(arcData));
  }, [isActive, arcData]);
  return _jsx(Path, Object.assign({
    d: path,
    stroke: color,
    fill: color
  }, {
    [isWeb ? 'onClick' : 'onPress']: onSelected
  }));
};